export default __webpack_public_path__ + "static/media/tr.6dcae8f0.svg";